import { Component, OnInit } from '@angular/core';
import { GlobalUser } from 'app/shared/services/user/global-user.model';
import { AppBuilderService } from 'app/forms/services/app-builder/app-builder.service';

@Component({
  selector: 'tog-admin-select-form',
  templateUrl: './admin-select-form.component.html',
  styleUrls: ['./admin-select-form.component.scss']
})
export class AdminSelectFormComponent implements OnInit {
  constructor(private _ab: AppBuilderService) { }

  get availableAdmins(): GlobalUser[] {
    return this._ab.availableAdmins;
  }

  get assignedAdmins(): GlobalUser[] {
    return this._ab.assignedAdmins;
  }

  ngOnInit() { }

  assignUser(user: any) {
    this._ab.assignUser(user);
  }

  removeUser(user: GlobalUser) {
    this._ab.removeUser(user);
  }
}



// WEBPACK FOOTER //
// /app/src/app/forms/components/admin-select-form/admin-select-form.component.ts